module.exports = __webpack_public_path__ + "static/media/feijaoclaro.d080ad1d.jpeg";